var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2509 0H2.7489C1.24988 0 -0.00012207 1.25 -0.00012207 2.74902V27.251C-0.00012207 28.75 1.24988 30 2.7489 30H27.2509C28.7499 30 29.9999 28.75 29.9999 27.251V2.74902C29.9999 1.25 28.7499 0 27.2509 0ZM8.74988 25H3.74988V11.25H8.74988V25ZM6.24988 9.62402C4.75085 9.62402 3.74988 8.62305 3.74988 7.37305C3.74988 6.00098 4.75085 5 6.24988 5C7.7489 5 8.74988 6.00098 8.74988 7.25098C8.74988 8.62305 7.7489 9.62402 6.24988 9.62402ZM26.2499 25H21.2499V17.5C21.2499 15.498 19.8729 15 19.5018 15C19.1259 15 17.4999 15.249 17.4999 17.5C17.4999 17.749 17.4999 25 17.4999 25H12.4999V11.25H17.4999V13.252C18.2518 12.124 19.5018 11.25 21.8749 11.25C24.2479 11.25 26.2499 13.125 26.2499 17.5V25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c4bad4dc73bc43ac2307f6ca6a0f98ca.svg";
export { ForwardRef as ReactComponent };